import { PageHeader } from 'components/PageHeader';
import { PageHeaderSkeleton } from 'components/PageHeaderSkeleton';
import { getTrans } from 'modules/i18n';
import {
  DateFormat,
  DEFAULT_TIMEZONE,
  formatDateWithTimezone
} from 'utils/date';
import { useShift } from '../hooks';

export const ShiftPageHeader = () => {
  const { shift, isLoading, isError } = useShift();

  const title = getTrans('pageTitles.shiftDetails');

  if (isLoading) {
    return <PageHeaderSkeleton title={title} subtitle={true} withBackBtn />;
  }

  if (!shift || isError) {
    return <PageHeader withBackBtn />;
  }

  const subtitleWithTimezone = shift?.reportedShiftStart
    ? formatDateWithTimezone(
        shift.reportedShiftStart,
        DateFormat.WEEKDAY_WITH_MONTH,
        DEFAULT_TIMEZONE
      )
    : '';

  return (
    <PageHeader title={title} subtitle={subtitleWithTimezone} withBackBtn />
  );
};
